import { render } from "./view_entity_type.html?vue&type=template&id=32a22b90&external"
import script from "./view_entity_type.js?vue&type=script&lang=js&external"
export * from "./view_entity_type.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__